export const errorConstants = {
  SET_ERROR: 'error/SET_ERROR',
  SET_ALERT: 'error/SET_ALERT',
  PLACE_ALERT: 'error/PLACE_ALERT',
};
